import React from 'react';
import { useTranslation } from 'react-i18next';

import { TitleBox, BulletTypography, SepTitle, TitleMain } from './TitleStyles';

interface TitleProps {
  titleKey: string;
  bulletless?: boolean;
  lineless?: boolean;
  centerTitle?: boolean;
  fontSize?: string | { xs?: string, sm?: string, md?: string };
  align?: 'start' | 'center' | 'end';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
}

const Title = ({ titleKey, bulletless, lineless, centerTitle, fontSize, align, children }: TitleProps) => {
  const { t } = useTranslation();

  return (
    <TitleBox sx={{
      justifyContent: centerTitle ? 'center' : 'space-between',
      alignItems: align || 'center'
    }}>
      <TitleMain sx={{ fontSize }}>
        {!bulletless && <BulletTypography>&nbsp;</BulletTypography>}
        {t(titleKey)}
      </TitleMain>
      {!lineless && <SepTitle sx={{ display: { xs: 'none', lg: 'block' } }}>&nbsp;</SepTitle>}
      {children}
    </TitleBox>
  );
};

export default Title;


